import { log } from '@/log'

/**
 * セッション状態のpayload。
 * serverのセッションcookie（mc_s）のJWT payloadと同一の形で、
 * X-Session-Stateミラーヘッダを通じてserverから通知される。
 */
export interface SessionPayload {
  id: string
  v: number
  startAt: number
  data: SessionData
}

export interface DataFulfilledSessionPayload extends SessionPayload {
  data: FulfilledSessionData
}

export type SessionData = FulfilledSessionData | EmptySessionData

export interface FulfilledSessionData {
  _marker: 'fulfilled'
  userId: string,
  userShortId: string,
  isRegistered: boolean
}

export interface EmptySessionData {
  _marker: 'empty'
}

export const isDataFulfilledSessionPayload =
  (payload: SessionPayload): payload is DataFulfilledSessionPayload =>
    payload.data._marker === 'fulfilled'

/**
 * serverから通知されたセッションpayloadを検証して返す。形が不正な場合はnullを返す
 */
export function parseSessionPayload(raw: any): SessionPayload | null {
  if (
    raw === null
    || typeof raw !== 'object'
    || typeof raw.id !== 'string'
    || typeof raw.v !== 'number'
    || typeof raw.startAt !== 'number'
    || typeof raw.data !== 'object'
    || raw.data === null
  ) {
    log.error('Invalid session payload', raw)

    return null
  }

  return {
    id: raw.id,
    v: raw.v,
    startAt: raw.startAt,
    data: parseSessionData(raw.data),
  }
}

function parseSessionData(data: any): FulfilledSessionData | EmptySessionData {
  const { userId, userShortId, isRegistered } = data
  if (userId === undefined && userShortId === undefined && isRegistered === undefined) {
    return { _marker: 'empty' }
  }

  if (typeof userId !== 'string' || typeof userShortId !== 'string' || typeof isRegistered !== 'boolean') {
    log.error('Invalid session data format, fallback to empty data', data)

    return { _marker: 'empty' }
  }

  if (userId.length === 0 || userShortId.length === 0) {
    log.error('Invalid session data format, fallback to empty data', data)

    return { _marker: 'empty' }
  }

  return { _marker: 'fulfilled', userId, userShortId, isRegistered }
}
